import Vue from 'vue'
import App from './App.vue'
import VueHtmlToPaper from 'vue-html-to-paper';
import axios from 'axios';
import {apiDomain,getHeader} from "./config/config";
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAkUdrVbgXV_52Qrid_vdeqzTbBfmFxrNM',
    libraries: 'places',
    language: 'en',
  }
});
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css"
  ]
};

Vue.use(VueHtmlToPaper, options);

Vue.config.productionTip = true
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

Vue.use(VueQuillEditor, /* { default global options } */)

//for the bootstrap vue
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-search-select/dist/VueSearchSelect.css' 
import {BootstrapVue,IconsPlugin} from 'bootstrap-vue'



Vue.use(IconsPlugin)
Vue.use(BootstrapVue)






// This imports all the layout components such as <b-container>, <b-row>, <b-col>:
import { LayoutPlugin } from 'bootstrap-vue'
Vue.use(LayoutPlugin)

// This imports <b-modal> as well as the v-b-modal directive as a plugin:
import { ModalPlugin } from 'bootstrap-vue'
Vue.use(ModalPlugin)

// This imports <b-card> along with all the <b-card-*> sub-components as a plugin:
import { CardPlugin } from 'bootstrap-vue'
Vue.use(CardPlugin)

// This imports directive v-b-scrollspy as a plugin:
import { VBScrollspyPlugin } from 'bootstrap-vue'
Vue.use(VBScrollspyPlugin)


import { library } from '@fortawesome/fontawesome-svg-core'
import { faWindowClose,faUserSecret,faCheck, faList, faPen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faUserSecret,faWindowClose,faCheck,faList,faPen)
 
Vue.component('font-awesome-icon', FontAwesomeIcon)
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'


Vue.use(VueMoment, {
    moment,
})

// Same money filter as the client SPA — splits the integer part by
// thousands (ru-RU non-breaking space). `{{ x | money }}` for 2-digit
// fraction, `{{ x | money(0) }}` for integers.
Vue.filter('money', (value, fraction = 2) => {
  if (value === null || value === undefined || value === '') return ''
  const num = Number(value)
  if (!Number.isFinite(num)) return value
  return num.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: fraction,
  })
})
//Vue.config.productionTip = false

// This imports the dropdown and table plugins
import { DropdownPlugin, TablePlugin } from 'bootstrap-vue'
Vue.use(DropdownPlugin)
Vue.use(TablePlugin)
import store from './store'
import router from './router'

// Global 401 handler — when the backend says the JWT is no longer
// valid (token expired, revoked, or the user is hitting a protected
// endpoint without one), drop the local session and push the user
// to /login so they're not left staring at a dead page. We hook the
// shared axios.defaults so EVERY component-level axios call inherits
// it, no per-call wiring needed.
axios.interceptors.response.use(
  resp => resp,
  err => {
    const status = err && err.response && err.response.status
    if (status === 401) {
      const onLogin = router.currentRoute && router.currentRoute.name === 'Login'
      if (!onLogin) {
        try { window.localStorage.removeItem('authUser') } catch (e) { /* ignore */ }
        router.replace({ name: 'Login' }).catch(() => {})
      }
    }
    return Promise.reject(err)
  }
)

import vuexI18n from 'vuex-i18n';
Vue.use(vuexI18n.plugin, store, {
	moduleName: 'i18n',
	onTranslationNotFound (locale, key) {

		// return new Promise((resolve, reject) => {
    //   axios.post(apiDomain+'/login/translations'
    //   ,{locale: locale, key:key},{headers:getHeader()})
		// 	.then((result) => {

		// 		resolve(result.data);
    //   })
    //   .catch(()=>{
    //     reject();
    //   })
		// });

	}}
);
// import predefined localizations
import translationsKz from './i18n/kz.js';
import translationsRu from './i18n/ru.js';
// add translations
Vue.i18n.add('kz', translationsKz);
Vue.i18n.add('ru', translationsRu);
// default locale is english
Vue.i18n.set('ru');
// synchronize the router with vuex
import {sync} from 'vuex-router-sync';
sync(store, router);

new Vue({
  
  router,
  store,
  render: h => h(App),
}).$mount('#app')
